import { componentSizeMap } from '@park-ui/constants'

import type { ComponentSize } from '@park-ui/constants'

export const getComponentSize = (size?: ComponentSize) => {
  return componentSizeMap[size || 'default']
}
